import { render, staticRenderFns } from "./ProductsLoading.vue?vue&type=template&id=736b3d3d&scoped=true&"
import script from "./ProductsLoading.vue?vue&type=script&lang=js&"
export * from "./ProductsLoading.vue?vue&type=script&lang=js&"
import style0 from "./ProductsLoading.vue?vue&type=style&index=0&id=736b3d3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736b3d3d",
  null
  
)

export default component.exports